// React & Vendor Libs
import React from 'react';
import ReactDOM from 'react-dom';

// Gallery Custom Links
import Settings from '@app/components/Settings';
import EditLinkField from '@app/components/EditLinkField';

let isMediaLibrary = null;

function init() {
	isMediaLibrary = document.getElementsByClassName('upload-php')[0];
}

// Gallery Custom Links Settings
function addSettings() {
	const container = document.getElementById('mgcl-admin-settings');
	if (container) {
		ReactDOM.render((<Settings />), container);
		return true;
	}
	return false;
}

document.addEventListener('DOMContentLoaded', function(event) {

	init();

	if (addSettings() || !isMediaLibrary) {
		return;
	}

	// Edit Link Fields need to be added in the Media Library
	const fields = Array.from(document.getElementsByClassName('mgcl-edit-link-field'));
	fields.forEach(field => {
		const postId = field.getAttribute('data-post-id');
		const url = field.getAttribute('data-url');
		const target = field.getAttribute('data-target');
		const rel = field.getAttribute('data-rel');
		const aria = field.getAttribute('data-aria');
		ReactDOM.render((<EditLinkField postId={postId} url={url} target={target} rel={rel} aria={aria} />), field);
	});

});
